<template>
  <div class="increment">
    <div class="increment-page-content">
      <div class="title">报告管理 MD审核</div>
      <div class="content">
        <div>
          <a-checkbox-group
            @change="onChange"
            :options="mdCheckLst"
            v-model="mdCheck"
          >
            <!-- <a-radio
              :value="item.key"
              v-for="item in mdCheckLst"
              v-if="item.key != 0"
              >{{ item.value }}</a-radio
            > -->
          </a-checkbox-group>
          <div class="increment-textarea">
            <div class="input-message">还可以输入1000个字</div>
            <a-textarea
              v-model="remark"
              placeholder="请输入输入审核意见......"
              :rows="4"
            />
          </div>
        </div>
        <div class="footer">
          <a-button
            @click="submit()"
            :loading="btnloading"
            style="width: 100px"
            type="primary"
            >确定</a-button
          >
          <a-button
            @click="closeModel"
            style="width: 100px; margin-left: 16px"
            class="ant-btn-custom"
            >取消</a-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["selectedData", "selectedId"],
  data() {
    return {
      mdCheck: [],
      remark: "",
      btnloading: false,
      mdCheckLst: [],
      mdInfo: {},
      selectedDataItem: {},
    };
  },
  mounted() {
    this.selectedDataItem = this.selectedData[0];
    this.getMdInfo();
    this.getMDCheckVal();
  },
  methods: {
    getMdInfo() {
      let bodyData = {};
      if (this.selectedDataItem.infoId) {
        bodyData = {
          itemId: this.selectedId,
          infoId: this.selectedDataItem.infoId,
        };
      } else {
        bodyData = { itemId: this.selectedId };
      }
      this.$get("md/getMdInfo", bodyData).then((res) => {
        if (res.data.code == 1) {
          this.mdInfo = res.data.data;
          if (!this.mdInfo.mdCheckRoleId) {
            this.mdCheck = [];
          } else {
            this.mdCheck =
              this.mdInfo.mdCheckKey.indexOf(",") != -1
                ? this.mdInfo.mdCheckKey.split(",")
                : [this.mdInfo.mdCheckKey];
          }

          this.remark = this.mdInfo.mdRemark;
        }
      });
    },
    getMDCheckVal() {
      this.mdCheckLst = [];
      this.$get("md/getMDCheckValue").then((res) => {
        if (res.data.code == 1) {
          let resData = res.data.data;
          resData.forEach((item) => {
            if (item.key != "0") {
              if (this.selectedDataItem.type == "edit") {
                this.mdCheckLst.push({
                  label: item.value,
                  value: item.key,
                  disabled: true,
                });
              } else {
                this.mdCheckLst.push({
                  label: item.value,
                  value: item.key,
                  disabled: false,
                });
              }
            }
          });
        }
      });
    },
    submit() {
      if (this.mdCheck.toString() == "") {
        this.$message.warning("请选择MD审核状态");
        return;
      } else if (this.selectedDataItem.type == "edit") {
        this.btnloading = true;
        this.$post(
          "md/editMDCheck",
          {
            id: this.selectedDataItem.infoId,
            state: this.mdCheck.toString(),
            remark: this.remark,
          },
          {
            "Content-Type": "application/json",
          }
        ).then(
          (res) => {
            if (res.data.code == 1) {
              this.$message.success("操作成功");
              this.$emit("close");
              this.$emit("update");
              this.btnloading = false;
            } else {
              this.$message.error(res.data.message);
              this.btnloading = false;
            }
          },
          () => {
            this.$message.error("操作失败");
            this.btnloading = false;
          }
        );
      } else {
        this.btnloading = true;
        this.$post(
          "md/setMDCheck",
          {
            itemId: this.selectedId,
            state: this.mdCheck.toString(),
            remark: this.remark,
          },
          {
            "Content-Type": "application/json",
          }
        ).then(
          (res) => {
            if (res.data.code == 1) {
              this.$message.success("操作成功");
              this.$emit("close");
              this.$emit("update");
              this.btnloading = false;
            } else {
              this.$message.error(res.data.message);
              this.btnloading = false;
            }
          },
          () => {
            this.$message.error("操作失败");
            this.btnloading = false;
          }
        );
      }
    },
    closeModel() {
      this.$emit("close");
    },
    onChange(e) {
      if (e && e.indexOf("1") != -1) {
        this.mdCheckLst.forEach((item) => {
          if (item.value !== "1") {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
          this.mdCheck = ["1"];
        });
      } else {
        this.mdCheckLst.forEach((item) => {
          item.disabled = false;
        });
      }
      console.log("d", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.increment {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: auto;
  .increment-page-content {
    width: 582px;
    margin: 80px auto 40px;
    .title {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 50px;
    }
    /deep/.content {
      border: 1px solid rgba(243, 245, 247, 1);
      padding: 30px 46px;
      width: 100%;
      .ant-radio-wrapper + .ant-radio-wrapper {
        margin-left: 10px;
      }
      .increment-textarea {
        height: 202px;
        position: relative;
        margin: 22px 0 14px 0;
        .input-message {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(164, 164, 164, 1);
          position: absolute;
          bottom: 10px;
          right: 10px;
          z-index: 2;
        }
        textarea {
          height: 202px;
          resize: none;
        }
      }
    }
    .footer {
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>